import { render, staticRenderFns } from "./MyProfile.vue?vue&type=template&id=582171ce&scoped=true"
import script from "./MyProfile.vue?vue&type=script&lang=ts"
export * from "./MyProfile.vue?vue&type=script&lang=ts"
import style0 from "./MyProfile.vue?vue&type=style&index=0&id=582171ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582171ce",
  null
  
)

export default component.exports